var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
export class FormSubmitGuard {
  constructor(formElement, options = {}) {
    /**
     * The form element.
     * @type {HTMLFormElement}
     * @private
     */
    __publicField(this, "formElement");
    /**
     * Indicates whether the form is valid.
     * @type {boolean}
     * @private
     */
    __publicField(this, "formValid", false);
    /**
     * Indicates whether the form is currently being submitted.
     * @type {boolean}
     * @private
     */
    __publicField(this, "submitInProgress", false);
    /**
     * The options for the FormSubmitGuard.
     * @type {Object}
     * @private
     */
    __publicField(this, "options");
    /**
     * The selector for the form action buttons.
     * @type {string}
     */
    __publicField(this, "formActionButtonsSelector", "button");
    this.formElement = formElement;
    this.options = options;
    this.formActionButtonsSelector = this.options.formActionButtonsSelector || this.formActionButtonsSelector;
    this.bindEvents();
    this.initListeners();
  }
  /**
   * Disable the form submit button.
   */
  disable() {
    this.getFormActionButtons().forEach((button) => button.setAttribute("disabled", "disabled"));
  }
  /**
   * Enable the form submit button.
   */
  enable() {
    this.getFormActionButtons().forEach((button) => button.removeAttribute("disabled"));
  }
  /**
   * Bind the event handlers.
   * @private
   */
  bindEvents() {
    this.handleFormInvalidEvent = this.handleFormInvalidEvent.bind(this);
    this.handleFormValidEvent = this.handleFormValidEvent.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  /**
   * Get the form actions root element.
   * @returns {HTMLElement | null}
   * @private
   */
  getFormActionsRootElement() {
    if (!this.formElement) {
      return null;
    }
    return this.formElement.querySelector(this.options.formActionsRoot);
  }
  /**
   * Get the form action buttons.
   * @returns {HTMLButtonElement[]}
   */
  getFormActionButtons() {
    const formActionsRootElement = this.getFormActionsRootElement();
    if (!formActionsRootElement) {
      return [];
    }
    return [...formActionsRootElement.querySelectorAll(this.formActionButtonsSelector)];
  }
  /**
   * Initialize the event listeners.
   * @private
   */
  initListeners() {
    const formActionsRootElement = this.getFormActionsRootElement();
    if (formActionsRootElement) {
      formActionsRootElement.addEventListener("click", this.handleSubmit);
    }
    if (this.formElement) {
      this.formElement.addEventListener("submit", this.handleSubmit);
    }
    $(document).on("forminvalid.zf.abide", this.handleFormInvalidEvent);
    $(document).on("formvalid.zf.abide", this.handleFormValidEvent);
  }
  /**
   * Handle the form submit event.
   * @param event {SubmitEvent}
   * @private
   */
  handleSubmit(event) {
    if (!event.target.closest(this.formActionButtonsSelector)) {
      return;
    }
    if (!this.formValid) {
      return;
    }
    event.preventDefault();
    if (this.submitInProgress) {
      return;
    }
    this.submitInProgress = true;
    this.disable();
  }
  /**
   * Handle the form invalid event.
   * @private
   */
  handleFormInvalidEvent() {
    this.formValid = false;
  }
  /**
   * Handle the form valid event.
   * @private
   */
  handleFormValidEvent() {
    this.formValid = true;
  }
}
export function createFormSubmitGuard(formElement, options = {}) {
  return new FormSubmitGuard(formElement, options);
}
